import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class GreyOverlayService {
  constructor() { }

/**
   * Enables the grey overlay on the page by:
   * - Setting the display style of the overlay container to 'flex'.
   * - Adding the 'enable-gray-overlay' class to the overlay element.
   *
   * This method assumes that elements with IDs 'grey-overlay-container' and 'grey-overlay'
   * exist in the DOM.
   * 
   * @param info - Configurable info text
   */
  enableGreyOverlay(info: string = "Processing..."): void {
    // enable overlay container
    const container = document.querySelector('#grey-overlay-container');
    const spinnerText = document.querySelector('#spinner-text');

    spinnerText!.textContent = info;

    (container as HTMLElement).style.display = 'flex';
    // enable overlay
    const element = document.querySelector('#grey-overlay');
    element?.classList.add('enable-gray-overlay');
  }

  /**
   * Disables the grey overlay by hiding the overlay container and
   * removing the 'enable-gray-overlay' class from the overlay element.
   *
   * This method targets elements with the IDs 'grey-overlay-container'
   * and 'grey-overlay' in the DOM. It sets the display style of the
   * container to 'none' and removes the overlay's active class.
   */
  disableGreyOverlay(): void {
    // disable overlay container
    const container = document.querySelector('#grey-overlay-container');
    (container as HTMLElement).style.display = 'none';
    // disable overlay
    const element = document.querySelector('#grey-overlay');
    element?.classList.remove('enable-gray-overlay');
  }
}
